module.exports = __webpack_public_path__ + "static/media/pencil.4dc48374.webp";